/**
 * Converts a string to kebab-case by collapsing each run of whitespace into a
 * single hyphen and lowercasing the result.
 *
 * Single source of truth for the "lowercase + whitespace to hyphen" transform.
 * Note that leading/trailing whitespace becomes a leading/trailing hyphen; the
 * value is not trimmed and no other characters are stripped or collapsed.
 *
 * @param value - The string to convert
 * @returns The kebab-cased string
 */
export function toKebabCase(value: string): string {
  return value.replace(/\s+/g, '-').toLowerCase();
}
